import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    dateFrom: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    dateTo: null,
    checkTo: true,

  },

  mutations: {
    setDateFrom(state, data) {
      state.dateFrom = data;
    },
    setDateTo(state, data) {
      state.dateTo = data;
    },
    setCheckTo(state, data) {
      state.checkTo = data;
    },
 
  },
  actions: {},
});
